import { useRef } from "react";
import { useParams } from 'react-router-dom';
import JobZImage from "../../../../common/jobz-img";
import { loadScript } from "../../../../../globals/constants";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axiosInstance from '../../../../../axiosInstance';
import { API_URL } from "../../../../../config";
import { Helmet } from 'react-helmet-async';
import { publicUrlFor } from "../../../../../globals/constants";
import { toast } from 'react-toastify';
import HCaptcha from "@hcaptcha/react-hcaptcha";

const colors = [
  "#E63946", // red
  "#457B9D", // blue-gray
  "#2A9D8F", // teal
  "#F4A261", // orange
  "#264653", // deep teal
  "#8E44AD", // purple
  "#D7263D", // crimson
  "#3A86FF", // vivid blue
  "#06D6A0", // mint green
  "#FFBE0B", // yellow
  "#8338EC", // violet
  "#FF006E", // pink
  "#118AB2", // bright blue
  "#073B4C", // dark navy
  "#F77F00", // deep orange
  "#38B000", // green
  "#7209B7", // purple
  "#FF7F50", // coral
  "#008080", // classic teal
];

function getRandomColor(seed) {
    const index = seed.charCodeAt(0) % colors.length;
    return colors[index];
}

function Candidate() {
    const { id } = useParams();
    const { t } = useTranslation();
    const formRef = useRef(null);
    const captchaRef = useRef(null);

    const [candidate, setCandidate] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [imgError, setImgError] = useState(false);
    const [file, setFile] = useState(null);
    const [captchaToken, setCaptchaToken] = useState(null);

    const [formData, setFormData] = useState({
        Name: "",
        companyName: "",
        EmpEmail: "",
        EmpNumber: "",
        Industry: "",
        JobTitle: "",
    });

    useEffect(() => {
        loadScript("js/custom.js");

        const fetchCandidate = async () => {
            try {
                const response = await axiosInstance.get(`${API_URL}/getCandidate/${id}`);
                const allUsers = response.data.data;

                setCandidate(allUsers);
                setLoading(false);
            } catch (err) {
                console.error("Error fetching users:", err);
                setError("Failed to load users. Please try again later.");
                setLoading(false);
            }
        };

        fetchCandidate();
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        if (type === "checkbox") {
            setFormData({ ...formData, [name]: checked });
        } else if (type === "file") {
            setFile(files[0]);
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { Name, companyName, EmpEmail, EmpNumber, Industry, JobTitle } = formData;

        if (!Name || !companyName || !EmpEmail || !EmpNumber || !Industry || !JobTitle) {
            toast.error("Please fill in all fields.");
            return;
        }

        if (!file) {
            toast.error("Please upload a job description file.");
            return;
        }

        if (!captchaToken) {
            toast.error("Please complete the CAPTCHA.");
            return;
        }

        const data = new FormData();
        data.append("Name", formData.Name);
        data.append("companyName", formData.companyName);
        data.append("EmpEmail", formData.EmpEmail);
        data.append("EmpNumber", formData.EmpNumber);
        data.append("Industry", formData.Industry);
        data.append("JobTitle", formData.JobTitle);
        data.append("file", file);

        try {
            const response = await axiosInstance.post(`${API_URL}/admin/employerCreateRequest`, data);
            console.log("Success:", response.data);
            toast.success("Form submitted successfully!");

            setFormData({
                Name: "",
                companyName: "",
                EmpEmail: "",
                EmpNumber: "",
                Industry: "",
                JobTitle: "",
            });
            setFile(null);
            setCaptchaToken(null);
            captchaRef.current?.resetCaptcha();
        } catch (error) {
            console.error("Error:", error.response?.data || error.message);

            if (error.response?.status === 409) {
                toast.error("Email already exists.");
            } else {
                toast.error(error?.response?.data?.message || "Submission failed!");
            }
        }
    };

    if (loading) return <div className="text-center my-5"><div className="spinner-border text-danger" /></div>;
    if (error) return <div className="text-danger text-center my-5">{error}</div>;

    return (
        <>
            <Helmet>
                <title>Worker | Job Contact</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>

            <div className="twm-candi-self-wrap-2 overlay-wraper" style={{ backgroundImage: `url(${publicUrlFor("images/candidates/candidate-bg2.jpg")})` }}>
                <div className="overlay-main site-bg-primary opacity-01" />
                <div className="container">
                    <div className="twm-candi-self-info-2">
                        <div className="twm-candi-self-top">
                            {/* <div className="twm-candi-fee">$20 / Day</div> */}
                            <div className="twm-media">
                                {candidate?.photo_url && !imgError ? (
                                    <img
                                        src={candidate.photo_url}
                                        alt="Profile"
                                        className="w-full h-auto rounded-full"
                                        onError={() => setImgError(true)}
                                    />
                                ) : (
                                    <div
                                        className="w-full h-auto rounded-full"
                                        style={{
                                            minWidth: "50px",
                                            backgroundColor: getRandomColor(candidate?.first_name?.[0]?.toUpperCase() || "A"),
                                            fontSize: "100px",
                                            fontWeight: "600",
                                            color: "#fff",
                                        }}
                                    >
                                        {candidate?.first_name
                                            ? `${candidate.first_name[0]}`.toUpperCase()
                                            : candidate?.first_name?.[0]?.toUpperCase() || "?"}
                                    </div>
                                )}
                            </div>
                            <div className="twm-mid-content">
                                <h4 className="twm-job-title">{candidate.first_name || t("Not specified")}</h4>
                                <p>{candidate.designation || ''}</p>
                                <p className="twm-candidate-address"><i className="feather-map-pin" />{candidate.country || t("Not specified")}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <h4 class="section-head-small mb-4">Profile Info</h4> */}
            <div class="twm-s-info-4">
                <div className="section-content">
                    <div className="container">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="twm-s-info-inner">
                                    <i class="fas fa-id-badge"></i>
                                    <span class="twm-title">{t("Reference number")}</span>
                                    <div class="twm-s-info-discription">JC#{candidate.id}</div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="twm-s-info-inner">
                                    <i class="fas fa-check-circle"></i>
                                    <span class="twm-title">{t("Status")}</span>
                                    <div class="twm-s-info-discription">{t("Available")}</div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="twm-s-info-inner">
                                    <i class="fas fa-user"></i>
                                    <span class="twm-title">{t("First name")}</span>
                                    <div class="twm-s-info-discription">{
                                        candidate.first_name.charAt(0).toUpperCase() + candidate.first_name.slice(1) || 'N/A'
                                    }</div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="twm-s-info-inner">
                                    <i class="fas fa-user-tie"></i>
                                    <span class="twm-title">{t("Designation")}</span>
                                    <div class="twm-s-info-discription">{candidate.designation || 'N/A'}</div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="twm-s-info-inner">
                                    <i class="fas fa-user-graduate"></i>
                                    <span class="twm-title">{t("Qualification")}</span>
                                    <div class="twm-s-info-discription">{candidate.qualification || 'N/A'}</div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="twm-s-info-inner">
                                    <i class="fas fa-map-marker-alt"></i>
                                    <span class="twm-title">{t("Country")}</span>
                                    <div class="twm-s-info-discription">{candidate.country || 'N/A'}</div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="twm-s-info-inner">
                                    <i class="fas  fa fa-briefcase"></i>
                                    <span class="twm-title">{t("Years of experience")}</span>
                                    <div class="twm-s-info-discription">{candidate.experience || 'N/A'}</div>
                                </div>
                            </div>
                            {/* <div class="col-md-6">
                                <div class="twm-s-info-inner">
                                    <i class="fas fa-map-marker-alt"></i>
                                    <span class="twm-title">{t("Field of employment")}</span>
                                    <div class="twm-s-info-discription">{candidate.coduntry || 'N/A'}</div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="section-full twm-contact-one p-t120" ref={formRef}>
                <div className="section-content">
                    <div className="container">
                        {/* CONTACT FORM*/}
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className="contact-form-outer">
                                    <div className="section-head left wt-small-separator-outer">
                                        <h2 className="wt-title">{t("Recruit With Us")}:</h2>
                                    </div>
                                    <form onSubmit={handleSubmit} className="cons-contact-form" method="post">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="nameInput">{t("Name")} :</label>
                                                    <input
                                                        id="nameInput"
                                                        name="Name"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Name"
                                                        value={formData.Name}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="companyInput">{t("Company Name")} :</label>
                                                    <input
                                                        id="companyInput"
                                                        name="companyName"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Company Name"
                                                        value={formData.companyName}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="emailInput">{t("Email")} :</label>
                                                    <input
                                                        id="emailInput"
                                                        name="EmpEmail"
                                                        type="email"
                                                        className="form-control"
                                                        placeholder="Email Address"
                                                        value={formData.EmpEmail}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="contactInput">{t("Contact No")} :</label>
                                                    <input
                                                        id="contactInput"
                                                        name="EmpNumber"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Contact Number"
                                                        value={formData.EmpNumber}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="industryInput">{t("Industry")} :</label>
                                                    <input
                                                        id="industryInput"
                                                        name="Industry"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Industry of Required Candidate"
                                                        value={formData.Industry}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group mb-3">
                                                    <label htmlFor="jobtitleInput">{t("JobTitle")} :</label>
                                                    <input
                                                        id="jobtitleInput"
                                                        name="JobTitle"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Job Title of Required Candidate"
                                                        value={formData.JobTitle}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form-group mb-3">
                                                    <label className="mb-2 font-medium text-gray-800">{t("Job Description Upload")}</label>
                                                    <div className="form-group mb-3 form-control">
                                                        <input
                                                            type="file"
                                                            name="file"
                                                            accept=".pdf"
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12 mt-4">
                                                <HCaptcha
                                                    sitekey={process.env.REACT_APP_HCAPTCHA_SITE_KEY}
                                                    onVerify={(token) => setCaptchaToken(token)}
                                                    ref={captchaRef}
                                                />
                                            </div>
                                            <div className="col-md-12 mt-3 mb-5">
                                                <button type="submit" className="site-button">{t("Submit Now")}</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* CANDIDATES START */}
            {/* <div className="section-full site-bg-white twm-candidate-h-page7-wrap pos-relative">
                <div className="container p-t80">
                    <div className="section-head center wt-small-separator-outer">
                        <h2 className="wt-title">{t("Candidate")}</h2>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-4 text-center mb-4 mb-md-0">
                            <div className="twm-media-pic">
                                <span>
                                    {candidate?.photo_url && !imgError ? (
                                        <img
                                            src={candidate.photo_url}
                                            alt="Profile"
                                            className="w-full h-auto rounded-full"
                                            onError={() => setImgError(true)}
                                        />
                                    ) : (
                                        <JobZImage src="images/candidates/pic7.jpg" alt="#" />
                                    )}
                                </span>
                            </div>
                        </div>

                        <div className="col-md-8">
                            <div className="border-start ps-4">
                                <p><strong className="text-danger">Numéro de référence:</strong> CRM#{candidate.id}</p>
                                <p><strong className="text-danger">Status:</strong> Disponible</p>
                                <p><strong className="text-danger">Prénom:</strong> {candidate.first_name}</p>
                                <p><strong className="text-danger">Pays:</strong> {candidate.country}</p>
                                <p><strong className="text-danger">Profession:</strong> {candidate.designation}</p>
                                <p><strong className="text-danger">Années d’expérience:</strong> {candidate.experience || '+3 ans'}</p>
                                <p><strong className="text-danger">Domaine d’emploi:</strong> {candidate.domain || 'Secteur de la santé'}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div > */}
            {/* CANDIDATES END */}
        </>
    )
}

export default Candidate;


// import { useParams } from 'react-router-dom';
// import { useEffect, useState } from 'react';
// import axiosInstance from '../../../../../axiosInstance';
// import { API_URL } from '../../../../../config';
// import { Helmet } from 'react-helmet-async';

// function CandidateProfilePage() {
//     const { id } = useParams(); // ← GET ID FROM URL
//     const [candidate, setCandidate] = useState(null);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchCandidate = async () => {
//             try {
//                 const res = await axiosInstance.get(`${API_URL}/getCandidate/${id}`);
//                 setCandidate(res.data.data);
//             } catch (err) {
//                 setError('Candidate not found');
//             }
//         };

//         fetchCandidate();
//     }, [id]);

//     if (error) return <div className="text-danger text-center">{error}</div>;
//     if (!candidate) return <div className="text-center">Loading...</div>;

//     return (
//         <>
//             <Helmet>
//                 <title>{candidate.first_name} | Candidate Profile</title>
//             </Helmet>

//             <div className="container p-5">
//                 <h2>{candidate.first_name} {candidate.last_name}</h2>
//                 <p><strong>Email:</strong> {candidate.email}</p>
//                 <p><strong>Designation:</strong> {candidate.designation}</p>
//                 <p><strong>Country:</strong> {candidate.country}</p>
//                 <p><strong>Salary:</strong> {candidate.salary} / Day</p>
//                 <img src={candidate.photo_url} alt="Candidate" style={{ width: 150, height: 150, borderRadius: '50%' }} />
//             </div>
//         </>
//     );
// }

// export default CandidateProfilePage;





// import { useLocation } from 'react-router-dom';
// import { Helmet } from 'react-helmet-async';

// function CandidateProfilePage() {
//     const { state } = useLocation();
//     const candidate = state?.candidate;

//     if (!candidate) return <div className="text-danger text-center">Candidate not found</div>;

//     return (
//         <>
//             <Helmet>
//                 <title>{candidate.first_name} | Candidate Profile</title>
//             </Helmet>

//             <div className="container p-5">
//                 <h2>{candidate.first_name} </h2>
//                 <p><strong>Email:</strong> {candidate.email}</p>
//                 <p><strong>Designation:</strong> {candidate.designation}</p>
//                 <p><strong>Country:</strong> {candidate.country}</p>
//                 <p><strong>Salary:</strong> {candidate.salary} / Day</p>
//                 <img src={candidate.photo_url} alt="Candidate" style={{ width: 150, height: 150, borderRadius: '50%' }} />
//             </div>
//         </>
//     );
// }

// export default CandidateProfilePage;